import "./style.css";

import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from "@material-ui/core";
import { Check, Close, Error } from "@material-ui/icons";
import React from "react";
import { setShowAlertQuestionContato } from "redux/Global/GlobalAction";

export default (props) => {
	const { global } = props.store;

	const handleClose = () => {
		props.dispatch(setShowAlertQuestionContato({ show: false }));
	};

	return (
		<>
			<Dialog
				open={global.showAlertQuestionContato.show}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<div className="bg-gray--light">
					<DialogContent>
						<DialogTitle id="alert-dialog-title" className="orange">
							<Error className="alert-question__title-icon" />
							{global.showAlertQuestionContato.title}
						</DialogTitle>
						<DialogContentText
							id="alert-dialog-description"
							className="alert-question__description"
						>
							{global.showAlertQuestionContato.text}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<div className="alert-question__btn-container ">
							<Button
								onClick={handleClose}
								autoFocus
								className="btn__gray--medium"
							>
								<Close className="alert-question__icon" />
								Não
							</Button>
							<Button
								onClick={props.handleConfirm}
								autoFocus
								className="btn__blue--medium"
							>
								<Check className="alert-question__icon" />
								Sim
							</Button>
						</div>
					</DialogActions>
				</div>
			</Dialog>
		</>
	);
};
